import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { paymentStatus } from "../lib/api";
import Seo from "../components/Seo";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentResult({ ok }) {
  const [params] = useSearchParams();
  const number = params.get("p") || "";
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (!number) return;
    let tries = 0;
    const check = () => paymentStatus(number).then((d) => {
      setStatus(d);
      if (!d.paid && tries < 4) { tries += 1; setTimeout(check, 2000); }
    }).catch(() => setStatus({ error: true }));
    check();
  }, [number]);

  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center" data-testid="payment-result">
      <Seo title={ok ? "Pago realizado | FABRIPAN" : "Pago no completado | FABRIPAN"} description="Resultado del pago." noindex />
      {ok ? (
        <>
          <CheckCircle2 className="h-16 w-16 text-emerald-500 mx-auto mb-4" />
          <h1 className="font-heading font-bold text-3xl tracking-tighter mb-2">¡Gracias por su pago!</h1>
          <p className="text-muted-foreground">Su pedido <strong>{number}</strong> se ha registrado.
            {status && !status.paid && <span className="block mt-2 text-sm flex items-center justify-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Confirmando el pago con el banco…</span>}
            {status && status.paid && <span className="block mt-2 text-emerald-600 font-medium">Pago confirmado.</span>}
          </p>
        </>
      ) : (
        <>
          <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
          <h1 className="font-heading font-bold text-3xl tracking-tighter mb-2">Pago no completado</h1>
          <p className="text-muted-foreground">El pago del pedido <strong>{number}</strong> no se ha realizado o fue cancelado. Puede intentarlo de nuevo o elegir transferencia bancaria.</p>
        </>
      )}
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/tienda" className="border border-border rounded-sm px-5 py-2.5 text-sm hover:border-brand">Volver a la tienda</Link>
        {!ok && <Link to="/carrito" className="bg-brand text-white rounded-sm px-5 py-2.5 text-sm font-semibold hover:bg-brand-dark">Reintentar pago</Link>}
      </div>
    </div>
  );
}
